import React, {Component} from 'react';

import strings from '../../strings';

import listen from '../../assets/listen.png';

import './styles.scss';

import {no_test, nn_test, se_test, de_test} from './assets';

class Test extends Component {
	constructor(props) {
		super(props);
		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = nn_test;
				break;
			case 'no':
				this.assets = no_test;
				break;
			case 'se':
				this.assets = se_test;
				break;
			case 'de':
				this.assets = de_test;
				break;
			default:
				this.assets = no_test;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {
  this.initializeAudio();

  // ✅ If we mount already on a step, start immediately
  this.startNewTask(this.props.currentStep);
}

componentWillUnmount() {
  clearTimeout(this.numbersTimer);
  clearTimeout(this.timeout);
}

	initializeAudio = () => {
  Object.values(this.assets).forEach((h) => {
    if (h && h.load) h.load();
  });
};

	startNewTask = (taskNumber) => {
  clearTimeout(this.numbersTimer);

  const key = 'sound' + (Number(taskNumber) + 1);

  // ✅ guard
  if (!this.assets[key]) {
    console.warn('No sound for step', taskNumber, 'expected key', key);
    return;
  }

  this.playNumbers([key]);
};
	playSound = (sound, onEnd) => {
  const howl = this.assets[sound];
  if (!howl) {
    console.warn('Missing sound asset:', sound);
    return;
  }

  // ✅ restart cleanly
  howl.stop();
  howl.seek(0);

  if (onEnd) {
    howl.once('end', onEnd); // ✅ no accumulating handlers
  }

  howl.play();
  howl.once('playerror', (id, err) => {
  console.warn('Howler playerror for', sound, err);
});
};

	playNumbers = (soundArray) => {
  if (!soundArray.length) return;

  const [first, ...rest] = soundArray;

  this.playSound(first, () => {
    if (rest.length) {
      this.playNumbers(rest);
    } else {
      this.props.startTimer();
    }
  });
};

	render() {
		return (
			<div className="Spoonerism">
				<img className="listen-image" src={listen} alt="" />
				<p>{strings.sp_instruction}</p>
			</div>
		);
	}
}

export default Test;
